var SecureMessageWidget = require('./../secure-message/SecureMessageWidget');
var ReceiptSummaryItemView = require('./ReceiptSummaryItemView');
var QueryParamPaginationView = require('./../pagination/QueryParamPaginationView');

var VIEW_NAME = 'receiptSummaryListWidget';

/**
 * Customizations to the SecureMessageWidget specific to the receipts list page.
 * @class ReceiptSummaryListWidget
 * @constructor
 * @extends SecureMessageWidget
 */
module.exports = SecureMessageWidget.extend({
  className: SecureMessageWidget.prototype.className + ' index--receipts',
  moduleNamespace: VIEW_NAME,

  headerMessageKey: VIEW_NAME + '.header',
  noDataMessageKey: VIEW_NAME + '.noMessages',
  loadingMessageKey: VIEW_NAME + '.loading',
  fetchFailedMessageKey: VIEW_NAME + '.fetchFailed',

  itemView: ReceiptSummaryItemView,

  /**
   * @method initialize
   * @override
   */
  initialize: function(options) {
    options = options || {};

    this.criteria = {
      receiptCriteria: {
        appointmentExternalIds: [options.appointmentExternalId]
      },
      isPatient: true,
      vecnaIds: null,
      pagingAndSorting: {
        pageNumber: 0,
        orderingMap: {
          actionDate: false
        },
        pageSize: 7
      }
    };

    SecureMessageWidget.prototype.initialize.apply(this, arguments);

    this._paginationView = new QueryParamPaginationView({
      pageParamName: 'receiptPage'
    });
    this.listenTo(this.collection, 'add change reset remove', this._triggerReceiptsUpdatedEvent);
  },

  /**
   * Trigger 'receipts-updated' event to let any listening views know that the collection of receipts have updated
   * @method _triggerReceiptsUpdatedEvent
   * @private
   */
  _triggerReceiptsUpdatedEvent: function() {
    this.trigger('receipts-updated');
  },

  /**
   * @method hasReceipts
   * @returns {Boolean} whether the list view retreived any receipts
   */
  hasReceipts: function() {
    return !!this.collection && this.collection.length > 0;
  },

  /**
   * @method receiptCount
   * @returns {undefined|Number} how many receipts the list view retreived
   */
  receiptCount: function() {
    return this.collection && this.collection.length;
  }
});

